import React from 'react'

type PlusIconProps = {
  size?: number
  color?: string
}

/**
 * TODO(design-gap): neither `ext-ui/svg/icon/` nor the legacy
 * `src/components/Svgs/` set has a plain "+" glyph — confirmed by search, not
 * an assumption. The prototype uses Heroicons' `PlusIcon` (a package
 * extend-app doesn't depend on and shouldn't add just for one icon — see the
 * `working-with-design-repos` skill's "never copy prototype code" rule).
 * This is a minimal stand-in, sized/colored via props so callers control it
 * like any other icon. REMOVE when design stocks a real ext-ui plus icon —
 * flagged on the docked ADS feedback list alongside the M1 gaps.
 */
export function PlusIcon({
  size = 16,
  color = 'currentColor',
}: PlusIconProps): React.ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox={'0 0 16 16'}
      fill={'none'}
      aria-hidden={'true'}
    >
      <path
        d={'M8 2.5V13.5M2.5 8H13.5'}
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap={'round'}
      />
    </svg>
  )
}
